export default "__VITE_ASSET__4a82b2e6__"